import { Eye } from "lucide-react";

// Reading tenders only: the home list, a tender's page, unlocking it with wallet points and
// recharging the wallet. Hidden from the services dashboard and never sold on its own; plans
// carry it, and both tender modules bundle it on the backend.
const manifest = {
  key: "tender_viewing",
  isFreeModule: false,
  isPurchasable: false,
  hidden: true,
  icon: Eye,
  names: {
    plan: {
      en: "Tender Viewing",
      ar: "استعراض المنافسات",
      "zh-Hans": "招标查看",
    },
    dashboard: {
      en: "Tender Viewing",
      ar: "استعراض المنافسات",
      "zh-Hans": "招标查看",
    },
  },
  defaultPath: "/tenders",
  // No matchers: the navbar keeps resolving these pages to the module that already owns them.
  matchers: [],
};

export default manifest;
